<script setup lang="ts">
defineProps<{
  tabKey: string;
  iconClass?: string;
  icon?: string;
  label?: string;
  active?: boolean;
  highlightColor?: string;
}>();
</script>

<template>

  <div
    role="button"
    class="
      group
      cursor-pointer
      text-sm  font-medium
      rounded-t-[4px] rounded-x-[4px]
      bg-white
      border border-x border-gray-300/70 dark:border-gray-700 dark:bg-gray-900"
    :style="{
      borderTopColor:   highlightColor,
      borderLeftColor:  highlightColor,
      borderRightColor: highlightColor,
      }"
    :class="[
      highlightColor ? 'border-2 border-x-2 relative -left-px ' : '',
      active ? 'dark:border-b-gray-900 border-b-white z-20 text-gray-900 dark:text-white' : 'border-b-gray-300/70 dark:border-b-gray-700 opacity-80 text-gray-500 dark:text-gray-300',
    ]">

    <slot>
      <div class="inline-flex items-center justify-center px-2 py-1.5">
        <UIcon
          v-if="icon"
          :name="icon"
          class="mr-1 text-[17px]"
          :class="iconClass" />
        <span>{{ label }}</span>
      </div>
    </slot>

  </div>

</template>
